var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_8058_2154)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29688 2.08398C5.19231 2.08398 4.29688 2.97942 4.29688 4.08399V20.9173C4.29688 22.0219 5.1923 22.9173 6.29688 22.9173H18.098C19.2026 22.9173 20.098 22.0219 20.098 20.9173V4.08398C20.098 4.08267 20.098 4.08135 20.098 4.08004V7.29232L15.2211 2.08398H6.29688Z",
    fill: "#FA4E4E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.366 16.1145C14.7077 16.0623 14.0739 15.8013 13.562 15.3313C12.5625 15.5662 11.6116 15.9056 10.6608 16.3234C9.90517 17.7592 9.19814 18.4902 8.58865 18.4902C8.46673 18.4902 8.32055 18.4642 8.22301 18.3858C7.95478 18.2553 7.80859 17.9681 7.80859 17.681C7.80859 17.4459 7.85736 16.7933 10.1733 15.7229C10.7097 14.6786 11.124 13.6083 11.4654 12.4858C11.1728 11.8592 10.539 10.3188 10.9777 9.53577C11.124 9.24853 11.4166 9.09189 11.7336 9.11806C11.9774 9.11806 12.2211 9.24853 12.3674 9.45739C12.6844 9.92731 12.66 10.9194 12.2455 12.3813C12.6356 13.1634 13.1466 13.8695 13.7569 14.4699C14.269 14.3653 14.7808 14.2871 15.2928 14.2871C16.4386 14.3131 16.6093 14.8875 16.5849 15.2269C16.5849 16.1145 15.7804 16.1145 15.366 16.1145ZM8.54001 17.733L8.61316 17.707C8.95442 17.5765 9.22253 17.3155 9.4176 16.976C9.05184 17.1326 8.75934 17.3937 8.54001 17.7332V17.733ZM11.7823 9.90127H11.7091C11.6847 9.90127 11.636 9.90127 11.6116 9.92731C11.5141 10.3711 11.5872 10.841 11.7579 11.2587C11.9042 10.8149 11.9042 10.345 11.7823 9.90127ZM11.953 13.6867L11.9286 13.7388L11.9042 13.7127C11.6847 14.3132 11.4409 14.9136 11.1728 15.488L11.2216 15.4619V15.514C11.7637 15.3041 12.3173 15.1297 12.8793 14.9919L12.855 14.9658H12.9281C12.5623 14.5742 12.2211 14.1304 11.953 13.6867ZM15.2684 15.0703C15.049 15.0703 14.854 15.0703 14.6345 15.1224C14.8784 15.253 15.1222 15.3052 15.366 15.3313C15.5366 15.3574 15.7073 15.3313 15.8535 15.2791C15.8535 15.2007 15.756 15.0703 15.2684 15.0703Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6379 6.80273H15.6758L20.0955 11.5228L20.0955 7.29102L19.6379 6.80273Z",
    fill: "url(#paint0_linear_8058_2154)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2208 2.08268L15.2208 2.41412C15.2208 5.10756 17.4042 7.29102 20.0977 7.29102L15.2208 2.08268Z",
    fill: "#FDB8B8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_8058_2154",
    x: 4.29688,
    y: 1.08398,
    width: 15.8008,
    height: 22.834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8058_2154"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_8058_2154",
    result: "effect2_innerShadow_8058_2154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8058_2154",
    x1: 16.6664,
    y1: 5.74479,
    x2: 21.3763,
    y2: 10.1549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.16a66b1ab8838b3b365053ae05a1d255.svg";
export { ForwardRef as ReactComponent };